<div class="board">
  <div class="head">
    <div>
      <h2>Outreach</h2>
      <p class="sub">
        Sharon talks to the members you choose, one cause at a time, and hands the thread to you the moment a person
        is needed. Nothing is sent without your click unless you put a conversation on Auto.
      </p>
    </div>
  </div>

  <div class="notice bad" *ngIf="overviewError">{{ overviewError }}</div>
  <ng-container *ngIf="overview as o">
    <div class="notice warn" *ngIf="!o.claudeConfigured">
      Claude key not set: Sharon runs on the QA stub and the copilot is unavailable.
    </div>
    <div class="notice warn" *ngIf="!o.drainerEnabled">
      The outreach drainer is off: nothing is drafted or sent on schedule. Decisions you make here still apply.
    </div>

    <div class="stats">
      <div class="stat"><div class="n">{{ o.counts.open }}</div><div class="l">Open</div></div>
      <div class="stat" [class.alert]="o.counts.frozen > 0"><div class="n">{{ o.counts.frozen }}</div><div class="l">Frozen</div></div>
      <div class="stat" [class.warn]="o.counts.pending_drafts > 0"><div class="n">{{ o.counts.pending_drafts }}</div><div class="l">Drafts waiting</div></div>
      <div class="stat"><div class="n">{{ o.counts.new_intel }}</div><div class="l">New intel</div></div>
      <div class="stat" [class.alert]="o.counts.overdue_intel > 0"><div class="n">{{ o.counts.overdue_intel }}</div><div class="l">Overdue intel</div></div>
      <div class="stat" [class.warn]="o.counts.pending_proposals > 0"><div class="n">{{ o.counts.pending_proposals }}</div><div class="l">Proposals</div></div>
    </div>
  </ng-container>

  <nav class="filters subtabs" aria-label="Outreach sections">
    <button *ngFor="let t of tabs" [class.on]="tab === t.id" (click)="show(t.id)">
      {{ t.label }}<span class="count" *ngIf="t.count">{{ t.count }}</span>
    </button>
  </nav>

  <app-outreach-copilot *ngIf="visited.has('copilot')" [hidden]="tab !== 'copilot'" [prefill]="prefill"
    [available]="overview?.claudeConfigured !== false"></app-outreach-copilot>

  <section *ngIf="visited.has('conversations')" [hidden]="tab !== 'conversations'" class="conversations">
    <div class="filters">
      <span class="label">Mode</span>
      <button [class.on]="!modeFilter" (click)="setModeFilter('')">All</button>
      <button *ngFor="let m of modes" [class.on]="modeFilter === m" (click)="setModeFilter(m)">{{ modeLabels[m] }}</button>
    </div>
    <div class="loading" *ngIf="loadingConversations"><mat-spinner diameter="28"></mat-spinner></div>
    <div class="notice bad" *ngIf="conversationsError">{{ conversationsError }}</div>
    <p class="empty" *ngIf="!loadingConversations && !conversationsError && !conversations.length">
      No conversations yet. Start one from a member's profile ("Sharon"), or ask the copilot who to talk to.
    </p>
    <div class="scroll" *ngIf="conversations.length">
      <table>
        <thead>
          <tr>
            <th>Member</th><th>Cause</th><th>Mode</th><th>State</th><th class="num">Sharon turns</th><th>Last activity</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of conversations" class="clickable" (click)="openConversation(c.id)">
            <td><a class="event-link" [routerLink]="['/admin/people/outreach/conversations', c.id]"
                (click)="$event.stopPropagation()">{{ c.memberName || c.userId }}</a></td>
            <td>{{ causeLabel(c.cause) }}</td>
            <td><span class="pill" [attr.data-mode]="c.mode">{{ modeLabels[c.mode] }}</span></td>
            <td class="meta">{{ stateLabels[c.state] || c.state }}</td>
            <td class="num">{{ c.botTurns }}/{{ c.maxBotTurns }}</td>
            <td class="meta">{{ c.lastActivityAt ? (c.lastActivityAt | date: 'd MMM, HH:mm') : '—' }}</td>
            <td>
              <div class="pills">
                <span class="pill rejected" *ngIf="c.mode === 'paused' && c.freezeReason">{{ freezeLabel(c.freezeReason) }}</span>
                <span class="pill pending" *ngIf="c.pendingDraft">Draft waiting</span>
                <span class="pill tag" *ngIf="c.isTest">Test</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="overview?.causes?.length">
      <h3>Causes</h3>
      <div class="scroll">
        <table>
          <thead>
            <tr>
              <th>Cause</th><th>Enabled</th><th>Auto</th><th class="num">Unedited in a row</th>
              <th class="num">Rejections (20)</th><th class="num">Freezes (10)</th><th>Ready</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of overview?.causes">
              <td><div class="title">{{ c.label }}</div><div class="meta">{{ c.goal }}</div></td>
              <td>{{ c.enabled ? 'Yes' : 'No' }}</td>
              <td>{{ c.trusted ? 'Trusted' : 'Assisted only' }}</td>
              <td class="num">{{ c.readiness.unEditedInARow }}/10</td>
              <td class="num">{{ c.readiness.rejectionsInLast20 }}</td>
              <td class="num">{{ c.readiness.freezesInLast10Conversations }}</td>
              <td>{{ c.readiness.ready ? 'Yes' : 'Not yet' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </section>

  <app-outreach-intel *ngIf="visited.has('intel')" [hidden]="tab !== 'intel'"
    (proposeNext)="askCopilot($event)"></app-outreach-intel>

  <app-outreach-simulator *ngIf="overview?.simulatorAvailable && visited.has('simulator')"
    [hidden]="tab !== 'simulator'"></app-outreach-simulator>
</div>
